import IWall from 'components/interfaces/IWall';

const wallFieldsFilled = (wall: IWall): boolean =>
  wall.length !== 0 && wall.thickness !== 0 && wall.roofHeight !== 0;

export default wallFieldsFilled;
